import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { useEffect } from 'react';
import { AutoCompleteSelectUI, FormLabelUI, InputUI } from '../../../Interface';
import { subtract } from 'mathjs';

const SzMOpWidgetGroupTable = ({ data, mode, valuesState = {}, autoCompleteOptions = {} }) => {
  const { setValues = () => {}, values = {} } = valuesState;

  useEffect(() => {
    const initialValues = {};

    data?.map((operation) => {
      if (!values?.[operation.productionoperationid]) {
        const remainingQty = subtract(Number(operation.productionQuantity || 0), Number(operation.prepQuantity || 0));

        initialValues[operation.productionoperationid] = {
          quantity: remainingQty > 0 ? remainingQty : '',
          scrapQuantity: '',
          scrapReasonId: null,
          description: '',
        };
      }
    });

    if (Object.keys(initialValues).length > 0) {
      setValues((prev) => ({
        ...prev,
        ...initialValues,
      }));
    }
  }, [data, setValues]);

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead sx={{ backgroundColor: '#CEDFE8' }}>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Cikkszám</TableCell>
            <TableCell>Cikknév</TableCell>
            <TableCell>Késztermék cikkszám</TableCell>
            <TableCell>Vevő neve</TableCell>
            <TableCell>Vevőhivatkozási szám</TableCell>
            <TableCell>Művelet</TableCell>
            {mode === 'quantityMode' && (
              <>
                <TableCell>Jó mennyiség</TableCell>
                <TableCell>Selejt mennyiség</TableCell>
                <TableCell>Selejt ok</TableCell>
              </>
            )}
            <TableCell>Megjegyzés</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((operation, index) => (
            <TableRow
              key={operation.productionoperationid || operation._productionoperationid}
              sx={{ backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'white' }}
            >
              <TableCell>{operation.productionoperationid}</TableCell>
              <TableCell>{operation.articleNumber}</TableCell>
              <TableCell>{operation.articleName}</TableCell>
              <TableCell>{operation.finishedItemCode}</TableCell>
              <TableCell>{operation.companyname}</TableCell>
              <TableCell>{operation?.reference}</TableCell>
              <TableCell>{operation.operationName}</TableCell>
              {mode === 'quantityMode' && (
                <>
                  <TableCell>
                    <InputUI
                      label={<FormLabelUI text="Jó mennyiség" />}
                      type="number"
                      value={values?.[operation.productionoperationid]?.quantity ?? ''}
                      onChange={(e) =>
                        setValues((prev) => ({
                          ...prev,
                          [operation.productionoperationid]: {
                            ...prev[operation.productionoperationid],
                            quantity: e.target.value,
                          },
                        }))
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <InputUI
                      label={<FormLabelUI text="Selejt mennyiség" />}
                      type="number"
                      onChange={(e) =>
                        setValues((prev) => ({
                          ...prev,
                          [operation.productionoperationid]: {
                            ...prev[operation.productionoperationid],
                            scrapQuantity: e.target.value,
                          },
                        }))
                      }
                    />
                  </TableCell>
                  <TableCell sx={{ width: '200px' }}>
                    <AutoCompleteSelectUI
                      label={<FormLabelUI text="Selejt ok" />}
                      onChange={(_e, newVal, reason) => {
                        if (reason === 'clear') {
                          setValues((prev) => ({
                            ...prev,
                            [operation.productionoperationid]: {
                              ...prev[operation.productionoperationid],
                              scrapReasonId: null,
                            },
                          }));
                        } else {
                          setValues((prev) => ({
                            ...prev,
                            [operation.productionoperationid]: {
                              ...prev[operation.productionoperationid],
                              scrapReasonId: newVal?.value,
                            },
                          }));
                        }
                      }}
                      selectedValue={values?.[operation.productionoperationid]?.scrapReasonId}
                      variant="outlined"
                      dataset={autoCompleteOptions.scrap ?? []}
                    />
                  </TableCell>
                </>
              )}
              <TableCell style={{ width: 250 }}>
                <InputUI
                  value={values?.[operation.productionoperationid]?.description}
                  onChange={(e) =>
                    setValues((prev) => ({
                      ...prev,
                      [operation.productionoperationid]: {
                        ...prev[operation.productionoperationid],
                        description: e.target.value,
                      },
                    }))
                  }
                  size="small"
                  multiline
                  rows={2}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SzMOpWidgetGroupTable;
